<template>
    <div class="roles-container" id="page-role">
        <img class="roles-title" src="https://staticweb.ewan.cn/resources/img/ddj-tw/role.png" alt="">
        <div class="roles-context">
            <div class="roles-left">
                <div class="roles-left-top">
                    <div v-for="item in selectItem" :key="item.type"
                        :class="['roles-top-btn', item.type == selectedItem ? 'active' : '']"
                        @click="seletItem(item.type)">{{ item.name }}</div>
                </div>
                <div class="roles-left-center">
                    <img class="roles-img" :src="rolesInfo.roleName" alt="">
                </div>
                <div :class="['roles-left-bottom', { 'animal': selectedItem === 'animal' }]">
                    <img class="roles-img-info" :src="rolesInfo.roleInfo" alt="">
                </div>
            </div>
            <div class="roles-right">
                <div class="role-pic" :class="selectedItem === 'animal' ? 'animal-pic' : ''">
                    <picture>
                        <source media="(max-width: 768px)" :srcset="rolesInfo.mobileRolePic">
                        <source media="(min-width: 769px)" :srcset="rolesInfo.rolePic">
                        <img src="" alt="">
                    </picture>
                    <div class="toggle-left" @click="toggleRole('right')"></div>
                    <div class="toggle-right" @click="toggleRole('left')"></div>
                </div>
                <!-- <div class="avatar-pic">
                    <ul :class="{ 'animal': selectedItem === 'animal' }">
                        <li v-for="(item, index) in dataList" :key="item.name"
                            :class="[selectedItem === 'animal' ? 'animal' : '']"
                            @click="selectAvatar(item.name, index)">
                            <img class="active-avatar" v-if="selectedRole === item.name" :src="item.picActivity" alt="">
                            <img v-else :src="item.pic" alt="">
                        </li>
                    </ul>
                </div> -->
            </div>
            <div class="roles-last" :class="selectedItem === 'animal' ? 'animal-last' : ''">
                <img v-for="(item, index) of typeList" @click="typeChange(item.name)"
                    :src="selectType === item.name || hoverType === item.name ? item.activeImgUrl : item.imgUrl"  @mouseenter="hoverType = item.name"  @mouseleave="hoverType = ''">
            </div>

        </div>
        <div class="rloes-coin-big">
            <img class="news-title" src="https://staticweb.ewan.cn/resources/img/ddj-tw/coin.png" alt="">
        </div>
        <div class="rloes-coin-samll">
            <img class="news-title" src="https://staticweb.ewan.cn/resources/img/ddj-tw/coin.png" alt="">
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            selectedItem: "people",
            selectedRole: "xz_avatar",
            selectType: "qgqc",
            hoverType: "",
            selectedIndex: 0,
            selectItem: [{
                type: "people",
                name: "人物"
            }, {
                type: "animal",
                name: "珍獸"
            }],
            peopleTypes: [{
                name: "qgqc",
                imgUrl: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/role-type-1.png",
                activeImgUrl: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/role-active-1.png",
            }, {
                name: "zzhy",
                imgUrl: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/role-type-2.png",
                activeImgUrl: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/role-active-2.png",

            }, {
                name: "sgsh",
                imgUrl: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/role-type-3.png",
                activeImgUrl: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/role-active-3.png",

            }, {
                name: "xycs",
                imgUrl: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/role-type-4.png",
                activeImgUrl: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/role-active-4.png",

            },],
            animalTypes: [{
                name: "sgrs",
                imgUrl: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/role-type-6.png",
                activeImgUrl: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/role-active-6.png",
            }, {
                name: "xyls",
                imgUrl: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/role-type-7.png",
                activeImgUrl: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/role-active-7.png",

            }, {
                name: "shqs",
                imgUrl: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/role-type-5.png",
                activeImgUrl: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/role-active-5.png",

            }],
            rolesInfo: {
                rolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/dc.png",
                roleName: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/dc_logo.png",
                roleInfo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/dc_info.png",
                mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_dc.png",
            },
            dataList: [],
            typeList: [],
            peopleList: [
                {
                    name: "dc_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/dc_logo.png",
                    info: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/dc_info.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/dc.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_dc.png",
                    type: "qgqc"
                },
                {
                    name: "wzj_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/wzj_logo.png",
                    info: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/wzj_info.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/wzj.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_wzj.png",
                    type: "qgqc"
                },
                {
                    name: "xs_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/xs_logo.png",
                    info: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/xs_info.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/xs.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_xs.png",
                    type: "qgqc"
                },
                {
                    name: "yyh_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/yyh_logo.png",
                    info: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/yyh_info.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/yyh.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_yyh.png",
                    type: "qgqc"
                },
                {
                    name: "zfy_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/zfy_logo.png",
                    info: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/zfy_info.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/zfy.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_zfy.png",
                    type: "qgqc"
                }, {
                    name: "cyy_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/cyy_logo.png",
                    info: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/cyy_info.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/cyy.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_cyy.png",
                    type: "zzhy"
                }, {
                    name: "dj_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/dj_logo.png",
                    info: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/dj_info.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/dj.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_dj.png",
                    type: "zzhy"
                }, {
                    name: "my_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/my_logo.png",
                    info: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/my_info.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/my.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_my.png",
                    type: "zzhy"
                }, {
                    name: "wzt_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/wzt_logo.png",
                    info: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/wzt_info.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/wzt.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_wzt.png",
                    type: "zzhy"
                }, {
                    name: "xf_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/xf_logo.png",
                    info: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/xf_info.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/xf.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_xf.png",
                    type: "zzhy"
                },

                {
                    name: "dy_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/dy_logo.png",
                    info: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/dy_info.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/dy.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_dy.png",
                    type: "sgsh"
                }, {
                    name: "fx_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/fx_logo.png",
                    info: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/fx_info.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/fx.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_fx.png",
                    type: "sgsh"
                }, {
                    name: "nw_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/nw_logo.png",
                    info: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/nw_info.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/nw.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_nw.png",
                    type: "sgsh"
                }, {
                    name: "pg_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/pg_logo.png",
                    info: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/pg_info.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/pg.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_pg.png",
                    type: "sgsh"
                }, {
                    name: "sn_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/sn_logo.png",
                    info: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/sn_info.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/sn.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_sn.png",
                    type: "sgsh"
                },
                {
                    name: "swj_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/swj_logo.png",
                    info: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/swj_info.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/swj.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_swj.png",
                    type: "xycs"
                }, {
                    name: "swk_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/swk_logo.png",
                    info: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/swk_info.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/swk.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_swk.png",
                    type: "xycs"
                }, {
                    name: "xbl_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/xbl_logo.png",
                    info: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/xbl_info.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/xbl.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_xbl.png",
                    type: "xycs"
                }, {
                    name: "zwn_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/zwn_logo.png",
                    info: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/zwn_info.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/zwn.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_zwn.png",
                    type: "xycs"
                }, {
                    name: "zx_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/zx_logo.png",
                    info: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/zx_info.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/zx.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_zx.png",
                    type: "xycs"
                },

            ],
            rolePeopleList: [],
            animalList: [
                {
                    name: "bn_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/bn_logo.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/bn.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_bn.png",
                    type: 'xyls'
                }, {
                    name: "lg_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/lg_logo.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/lg.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_lg.png",
                    type: 'xyls'
                }, {
                    name: "mm_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/mm_logo.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/mm.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_mm.png",
                    type: 'xyls'
                }, {
                    name: "tt_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/tt_logo.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/tt.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_tt.png",
                    type: 'xyls'
                }, {
                    name: "xn_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/xn_logo.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/xn.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_xn.png",
                    type: 'xyls'
                },

                {
                    name: "bf_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/bf_logo.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/bf.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_bf.png",
                    type: 'sgrs'
                },
                {
                    name: "bz_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/bz_logo.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/bz.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_bz.png",
                    type: 'sgrs'
                },
                {
                    name: "jl_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/jl_logo.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/jl.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_jl.png",
                    type: 'sgrs'
                },
                {
                    name: "ql_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/ql_logo.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/ql.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_ql.png",
                    type: 'sgrs'
                },
                {
                    name: "qr_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/qr_logo.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/qr.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_qr.png",
                    type: 'sgrs'
                },
                {
                    name: "ct_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/ct_logo.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/ct.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_ct.png",
                    type: 'shqs'
                },
                {
                    name: "ks_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/ks_logo.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/ks.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_ks.png",
                    type: 'shqs'
                },
                {
                    name: "ms_avatar",
                    logo: "https://staticweb.ewan.cn/resources/img/ddj-tw/new/ms_logo.png",
                    pic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/ms.png",
                    mobileRolePic:"https://staticweb.ewan.cn/resources/img/ddj-tw/new/m_ms.png",
                    type: 'shqs'
                },
            ],
            roleAnimalList: [
               
            ],
            clientWidth: 1920,
        }
    },
    created() {
        this.dataList = this.peopleList.filter(x => x.type === this.selectType);
        this.typeList = this.peopleTypes
    },
    methods: {
        seletItem(type) {
            this.selectedItem = type;
            this.selectedIndex = 0;
            this.selectItem.forEach(el => {
                this.typeList = this.peopleTypes
                this.selectType = this.peopleTypes[0].name
                this.selectedRole = this.peopleList[0].name
                this.dataList = this.peopleList.filter(x => x.type === this.selectType);
                if (el.type === this.selectedItem && this.selectedItem === "animal") {
                    this.typeList = this.animalTypes
                    this.selectType = this.animalTypes[0].name
                    this.selectedRole = this.animalList[0].name
                    this.dataList = this.animalList.filter(x => x.type === this.selectType);
                }
                this.rolesInfo = {
                    rolePic: this.dataList[0].pic,
                    roleName: this.dataList[0].logo,
                    roleInfo: this.dataList[0].info,
                    mobileRolePic: this.dataList[0].mobileRolePic,
                }
            })
        },
        typeChange(name) {
            this.selectType = name;
            this.selectedIndex = 0;
            let key = this.selectedItem === "animal" ? 'animalList' : 'peopleList';
            this.dataList = this[key].filter(x => x.type === name);
            this.rolesInfo = {
                rolePic: this.dataList[0].pic,
                roleName: this.dataList[0].logo,
                roleInfo: this.dataList[0].info,
                mobileRolePic: this.dataList[0].mobileRolePic,
            }
        },
        selectAvatar(name, index) {
            this.selectedRole = name;
            this.selectedIndex = index;
            let key = this.selectedItem === "animal" ? 'animalList' : 'peopleList';
            this[key].forEach(el => {
                if (el.name === name) {
                    this.rolesInfo = {
                        rolePic: el.pic,
                        roleName: el.logo,
                        roleInfo: el.info,
                        mobileRolePic: el.mobileRolePic,
                    }
                }

            })
        },
        toggleRole(direction) {
            let key = this.selectedItem === "animal" ? 'dataList' : 'dataList';
            if (direction == 'left') {
                this.selectedIndex = this.selectedIndex == 0 ? this[key].length - 1 : this.selectedIndex - 1
            } else {
                this.selectedIndex = this.selectedIndex == this[key].length - 1 ? 0 : this.selectedIndex + 1
            }

            this.rolesInfo = {
                rolePic: this[key][this.selectedIndex].pic,
                roleName: this[key][this.selectedIndex].logo,
                roleInfo: this[key][this.selectedIndex].info,
                mobileRolePic: this[key][this.selectedIndex].mobileRolePic,
            }
            this.selectedRole = this[key][this.selectedIndex].name;
        }
    }
}
</script>
<style scoped lang="scss" src="./scss/roles.scss">
</style>